const translations = {
    close: 'Close',
    closeLabel: 'Close member details'
};

export default translations;
